import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import { FC } from 'react';

const useStyles = makeStyles(() => ({
  loaderWrapper: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 2,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'white',
  },
  loader: {
    zIndex: 10,
    display: 'hidden',
  },
}));
export const Loader: FC = () => {
  const classes = useStyles();
  return (
    <div className={classes.loaderWrapper}>
      <CircularProgress
        classes={{
          root: classes.loader,
        }}
        size={70}
        thickness={2.4}
      />
    </div>
  );
};
